import { MutateFn } from '@diritto/common/base/mutateFunction';
import { ReplyReportRequestDto } from '@diritto/common/reply/dtos/reply-report.request.dto';
import { useMutation } from '@tanstack/react-query';
import { ReplyApi } from 'api/ApiHelper';

export const useReportReplyMutation = (callback: MutateFn) =>
  useMutation({
    mutationFn: ({ replyId, payload }: { replyId: number; payload: ReplyReportRequestDto }) =>
      ReplyApi.reportReply(replyId, payload),
    ...callback,
  });
